import React from 'react';
import {connect} from 'react-redux';
import EpiContext from '@episerver/spa-core/Spa';
import Config from 'app/Config';
import {OwnershipTransferPrivateBuyerStep} from './Constant/Constant';
import {setCurrentStep, setShowPopUp, resetState} from './OwnershipTransferBuyerSlice';
import GeneralMessage from './Steps/GeneralMessage';
import SelectPackage from './Steps/SelectPackage';
import SelectBan from './Steps/SelectBan';
import CustomerData from './Steps/CustomerData';
import CustomerAddress from './Steps/CustomerAddress';
import PaymentData from './Steps/PaymentData';
import Loading from './Steps/Loading';

const OwnershipTransferBuyerMain = (props) => {
  const generalMessageActions = {
    privateLobby: () => EpiContext.navigateTo(Config.lobbyUrl),
  };

  let currentStep = () => {
    switch (props.data.currentStep) {
      case OwnershipTransferPrivateBuyerStep.Loading:
        return <Loading />;
      case OwnershipTransferPrivateBuyerStep.SelectPackage:
        return <SelectPackage iContent={props.iContent} />;
      case OwnershipTransferPrivateBuyerStep.SelectBan:
        return <SelectBan />;
      case OwnershipTransferPrivateBuyerStep.CustomerData:
        return <CustomerData />;
      case OwnershipTransferPrivateBuyerStep.CustomerAddress:
        return <CustomerAddress />;
      case OwnershipTransferPrivateBuyerStep.PaymentData:
        return <PaymentData />;
      case OwnershipTransferPrivateBuyerStep.GeneralMessage:
        return (
          <GeneralMessage
            messageData={props.data.generalMessage}
            buttonClick={generalMessageActions[props.data.generalMessage?.buttonClick]}
            secondButtonClick={generalMessageActions[props.data.generalMessage?.secondButtonClick]}
          />
        );
      default:
        break;
    }
  };
  return <>{currentStep()}</>;
};

const mapStateToProps = (state) => ({
  data: state.OwnershipTransferPrivateBuyer,
});

const mapDispatchToProps = {
  resetState,
  setCurrentStep,
  setShowPopUp,
};

export default connect(mapStateToProps, mapDispatchToProps)(OwnershipTransferBuyerMain);
